/**
 * Airtable Service Index
 * Switches between real and mock service based on environment
 */

import { AirtableService } from './airtableService';
import { AirtableMockService } from './airtableMockService';

// Use mock service if REACT_APP_USE_MOCK_DATA is true
const useMock = process.env.REACT_APP_USE_MOCK_DATA === 'true';

export default useMock ? AirtableMockService : AirtableService;
